export const SET_HOVER_EVENT_TARGET = 'search/eventCard/hover';
export const setHoverEventTarget = (eid) => ({
    type: SET_HOVER_EVENT_TARGET,
    payload: eid,
});

export const GOOGLE_MAPS_SCRIPT_LOADED = 'search/map/load';
export const setGoogleMapsLoaded = () => ({
    type: GOOGLE_MAPS_SCRIPT_LOADED,
});
